import { Component, EventEmitter, Input, Output, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.css'],
})
export class CustomDropdownComponent {

  @Input() parentForm: FormGroup = new FormGroup({});
  @Input() nameInput: string = 'nameInput';
  @Input() isSubmit: boolean = false;
  get nombreFormGroup(){
    return this.parentForm.get(this.nameInput);
  }

  value?: any;

  @Input() data!: any;
  @Input() label!: any;
  @Input() optionValue!: any;
  @Input() withFilter: boolean = false;
  @Input() dataKey: string = '';
  @Input() placeholder: string = '';

  @Input()
  set ngValue(value: any) {
    this.value = value;
    this.ngValueChange.emit(this.value);
  }

  get ngValue() {
    return this.value;
  }

  @Output()
  ngValueChange = new EventEmitter<any>();

  @Output()
  onChange: EventEmitter<any> = new EventEmitter();

  onSelection(item: any): void {
    this.onChange!.emit(item);
  }
}
